/**
 * Dealership Information Configuration
 * 
 * Single source of truth for all business contact information displayed on the site.
 * 
 * IMPORTANT: This is for DISPLAY purposes only.
 * Email routing for enquiry notifications is handled by backend MECHANIC_EMAIL env var.
 */

// Logo configuration - easily replaceable
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_dealer-app/artifacts/k5tpn7e3_Untitled_design__5_-removebg.png';

export const DEALERSHIP_INFO = {
  // Business Name
  name: 'CMAC&SON AUTOS LIMITED',
  shortName: 'CMAC & SON AUTOS',
  tagline: 'Autos Ltd',
  
  // Contact Information (Display Only)
  phone: '087 110 5223',
  phoneHref: 'tel:+353871105223',
  email: 'cmacandsonautos@gmail.com',
  emailHref: 'mailto:cmacandsonautos@gmail.com',
  
  // Address
  address: {
    line1: 'Two mile Inn',
    line2: 'Ballyedekin',
    city: 'Cork',
    postcode: 'P25 F961',
    full: 'Two mile Inn, Ballyedekin, Cork, P25 F961'
  },
  
  // Opening Hours
  hours: {
    monday: '8am–7pm',
    tuesday: '8am–7pm',
    wednesday: '8am–6pm',
    thursday: '8am–7pm',
    friday: '8am–7pm',
    saturday: '8am–7pm',
    sunday: 'Closed'
  },
  
  // Formatted hours for display
  hoursFormatted: [
    { day: 'Monday', time: '8am–7pm' },
    { day: 'Tuesday', time: '8am–7pm' },
    { day: 'Wednesday', time: '8am–6pm' },
    { day: 'Thursday', time: '8am–7pm' },
    { day: 'Friday', time: '8am–7pm' },
    { day: 'Saturday', time: '8am–7pm' },
    { day: 'Sunday', time: 'Closed' }
  ],
  
  // Short hours summary for compact displays
  hoursSummary: 'Mon–Sat: 8am–7pm, Sun: Closed',
  
  // Legal / Copyright
  copyrightYear: 2026,
  copyright: '© 2026 CMAC&SON AUTOS LIMITED'
};

// Finance Disclaimer
export const FINANCE_DISCLAIMER = 'Finance figures are indicative only and subject to approval. Final monthly payments, interest rates, and terms may vary.';

export default DEALERSHIP_INFO;
